var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改项目信息",
            visible: _vm.dialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目编号：", prop: "projectNumber" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入项目编号" },
                    model: {
                      value: _vm.form.projectNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "projectNumber", $$v)
                      },
                      expression: "form.projectNumber",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "申请编号：", prop: "applicationNumber" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入申请编号" },
                        model: {
                          value: _vm.form.applicationNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicationNumber", $$v)
                          },
                          expression: "form.applicationNumber",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "公司：", prop: "companyId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择公司",
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.handleCompanyChange },
                      model: {
                        value: _vm.form.companyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "companyId", $$v)
                        },
                        expression: "form.companyId",
                      },
                    },
                    _vm._l(_vm.companyOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发卡类型：", prop: "sendType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择发卡类型" },
                      model: {
                        value: _vm.form.sendType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sendType", $$v)
                        },
                        expression: "form.sendType",
                      },
                    },
                    _vm._l(_vm.cardTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "销售价：", prop: "salesPrice" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { precision: 2, step: 0.01, min: 0 },
                    model: {
                      value: _vm.form.salesPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "salesPrice", $$v)
                      },
                      expression: "form.salesPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发放原因：", prop: "reason" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内部备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "innerRemark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.innerRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "innerRemark", $$v)
                      },
                      expression: "form.innerRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }